import { trackPendoEvent } from 'services/PendoService';

import type { MultiRunIntroDismissReason } from './MultiRunIntroModal';

/**
 * Reach and dismissal for the one-time introduction (EN-10791).
 *
 * A one-shot modal's first days are its whole audience, so the measurement has
 * to ship with it or it is gone. Every event carries the edition, so the
 * launch week and the Omaha week can be measured apart. Event names confirmed
 * by Cory, who owns the data definitions (EN-10791, 2026-09-29). Production
 * stages only (the Pendo allowlist), no player identity in the payload (Pendo
 * already keys the visitor on playerGUID), only the edition id and never its
 * copy, and analytics never blocks the modal.
 */

/**
 * How a showing ended: the player's own dismissal, or 'interrupted' when the
 * app closed it without counting it as seen (live play, the location, leaving
 * the lobby, the flag or the biometric sheet). Every showing reports exactly
 * one, so shown and dismissed add up (Cory, EN-10791).
 */
export type MultiRunIntroCloseReason = MultiRunIntroDismissReason | 'interrupted';

type MultiRunIntroEvent =
  | { name: 'multi_run_intro_shown'; edition: string }
  | { name: 'multi_run_intro_dismissed'; edition: string; reason: MultiRunIntroCloseReason };

/** Sent through PendoService, so it waits for this player's identified visitor. */
export const reportMultiRunIntroEvent = (event: MultiRunIntroEvent, playerGUID: string): void => {
  const { name, ...properties } = event;
  trackPendoEvent({ playerGUID, eventName: name, properties });
};
